module.exports = __webpack_public_path__ + "media/images/donate-banner-dd7a86116d4f331333a80768646f9479.png";